import React from 'react'
import { useLocation, useParams } from 'react-router-dom'

export default function Title({ children }) {
    const location = useLocation()
    return (
        <div className='main-title'>
            {children}
        </div>
    )
}
